module.exports = __webpack_public_path__ + "2d3943c1acdaba5e526d615baf0f9b22.svg";


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/4x3/sm.svg
// module id = ./node_modules/flag-icon-css/flags/4x3/sm.svg
// module chunks = 0